// extracted by mini-css-extract-plugin
export default {"card":"wNIg4kVV","content":"mtTiZRJl","rubric":"jYg8f3eT","body":"ghM6n3l_","image":"chvddiwf"};